import React, { useEffect, useState } from "react";
import { getOrderDetail, getOrderDetailByAdmin } from "../../../../services/LocationService";
import { PriceDetail } from "../../../../models/Order";
import {
	userGetAbout,
	userGetContact,
	userGetCookiePolicy,
	userGetPrivacyPolicy,
	userGetTerm,
	userGetTermOfUse,
} from "../../../../services/UserService";
import { PaymentMethod } from "../../../../models/User";

export default function useContent(props: { dialogType: string; openDialog: boolean }) {
	const [content, setContent] = useState<string>("");

	const getContent = async (dialogType: string): Promise<{ data: string }> => {
		switch (dialogType) {
			case "terms_of_use":
				return await userGetTermOfUse();
			case "terms_conditions":
				return await userGetTerm();
			case "privacy_policy":
				return await userGetPrivacyPolicy();
			case "cookie_policy":
				return await userGetCookiePolicy();
			case "about_us":
				return await userGetAbout();
			case "contact_us":
				return await userGetContact();
			default:
				return {data:""}
		}
	};

	const loadContent = async () => {
		try {
			const res = await getContent(props.dialogType);
			setContent(res.data);
		} catch (err) {
			console.error(err);
		}
	};
	const reload = () => {
		loadContent();
	};
	useEffect(() => {
		if (props.openDialog) {
			reload();
		}
	}, [props.dialogType, props.openDialog]);
	return {
		content,
		setContent,
		reload,
	};
}
